import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { FileDownloadOutlined, ListAltOutlined, Payment, WorkOutline } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { WorkerDetails, WorkerStatement } from "../../components/worker";
import { PageHeader } from "../../components/v3";
import { ADD_WORKER_PAYMENT, ADD_WORK, VIEW_WORKER_STATEMENT, GENERATE_WORKER_REPORT } from "../../constants";
import { useHasPermission } from "../../utils";

export const SingleWorker = () => {
  const [name, setName] = useState("");
  const [isGroupWorker, setIsGroupWorker] = useState(false);
  const [reload, setReload] = useState(0);

  const { id } = useParams();
  const navigate = useNavigate();

  const hasAddWork = useHasPermission(ADD_WORK);
  const hasAddPayment = useHasPermission(ADD_WORKER_PAYMENT);
  const hasViewStatement = useHasPermission(VIEW_WORKER_STATEMENT);
  const hasGenerateReport = useHasPermission(GENERATE_WORKER_REPORT);

  const handleReload = () => setReload((prev) => prev + 1);

  const handleWorkerLoaded = (workerName, groupWorker) => {
    setName(workerName);
    setIsGroupWorker(Boolean(groupWorker));
  };

  const buttons = [
    hasAddWork && {
      buttonText: "Add Work",
      buttonIcon: WorkOutline,
      onClick: () => navigate(`/add-work?workerId=${id}`),
    },
    hasAddPayment && {
      buttonText: "Add Payment",
      buttonIcon: Payment,
      onClick: () => navigate(`/transaction/add?workerId=${id}`),
    },
    hasGenerateReport && {
      buttonText: "Download Report",
      buttonIcon: FileDownloadOutlined,
      onClick: () => navigate(`/reports/worker?workerId=${id}`),
    },
    isGroupWorker && {
      buttonText: "Manage Particulars",
      buttonIcon: ListAltOutlined,
      onClick: () => navigate(`/worker/${id}/particulars`),
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title="Worker Details"
            // button
            buttons={buttons}
          />
        </Box>

        {/* details */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <WorkerDetails onSuccess={handleWorkerLoaded} reloadData={reload} />
        </Box>

        {/* worker statement */}
        {hasViewStatement && (
          <WorkerStatement name={name} isGroupWorker={isGroupWorker} onSuccess={handleReload} reloadData={reload} />
        )}
      </PageLayout>
    </>
  );
};
